import { useSelector } from 'react-redux';
import { examsSelectors } from '../slices/exams/examsSlice';
import {
  isComlexExam,
  isCustomExam,
  isNbmeExam,
  isNclexExam,
  isPreclinicalExam,
} from '../utils/examUtils';
import { useMemo } from 'react';

/**
 * Hook to determine the type of the primary exam
 * @returns Object containing boolean indicators for exam type
 */
export const usePrimaryExamType = () => {
  const primaryExam = useSelector(examsSelectors.selectPrimaryExam);

  const derivedValues = useMemo(() => {
    const isNbme = isNbmeExam(primaryExam);
    const isComlex = isComlexExam(primaryExam);
    const isNclex = isNclexExam(primaryExam);
    const isPreclinical = isPreclinicalExam(primaryExam);
    // Keep legacy `isCustom` semantics as \"preclinical mode\" for existing UI flows.
    const isCustom = isCustomExam(primaryExam) || isPreclinical;

    return { isNbme, isCustom, isComlex, isNclex, isPreclinical };
  }, [primaryExam?.id, primaryExam?.type]); // Only recalculate when these specific fields change

  return {
    ...derivedValues,
    primaryExam,
  };
};
